import { Grid, Icon } from 'gu-ui-kit'
import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import useWriteToClipboard from 'utils/hooks/useWriteToClipboard'
import styles from 'modules/Recommendations/CampaignsRecommendations/Type/subcomponents/List/list.module.scss'
import { notificationShow } from 'modules/Notifications/actions'
import { useDispatch } from 'react-redux'
import formatMoney from 'utils/formatMoney'

export default ({ setSorting, setColumnVisibility, ...rest }) => {
  const dispatch = useDispatch()
  const writeToClipboard = useWriteToClipboard()
  const breakpoints = useBreakpoint()
  const { t } = useTranslation()

  const toClipboard = useCallback((text) => {
    writeToClipboard(text)

    dispatch(
      notificationShow({
        type: 'success',
        message: 'common::notifications.success_copy_notification',
      }),
    )
  }, [])

  useEffect(() => {
    if (!breakpoints.md) {
        setColumnVisibility({})
    } else if (!breakpoints.lg) {
        setColumnVisibility({})
    } else {
        setColumnVisibility({})
    }
  }, [breakpoints])

  return {
    columns: [
      {
        id: 'account_login',
        accessorKey: 'account_login',
        header: t(
          'recommendations::type.strategy-learning.table.head.account_login.label',
        ),
        cell: ({
          row: {
            original: { account_login },
          },
        }) => (
          <Grid gap={10} wrap={'nowrap'}>
            {account_login}
            <span
              onClick={() => toClipboard(account_login)}
              className={styles['copy-button']}
            >
              <Icon name={'copy'} width={20} color={'Interface-Seventh'} />
            </span>
          </Grid>
        ),
      },
      {
        id: 'campaign_id',
        accessorKey: 'campaign_id',
        header: t(
          'recommendations::type.strategy-learning.table.head.campaign_id.label',
        ),
        cell: ({
          row: {
            original: { campaign_id },
          },
        }) => (
          <Grid gap={10} wrap={'nowrap'}>
            {campaign_id}
            <span
              onClick={() => toClipboard(campaign_id)}
              className={styles['copy-button']}
            >
              <Icon name={'copy'} width={20} color={'Interface-Seventh'} />
            </span>
          </Grid>
        ),
      },
      {
        id: 'type',
        header: t('recommendations::type.action-cost.table.head.type.label'),
        cell: ({
          row: {
            original: { type, platform },
          },
        }) => (
          <span>
            {type} (
            {t(`recommendations::type.filters.platforms.options.${platform}`)})
          </span>
        ),
      },
      {
        id: 'cost',
        accessorKey: 'cost',
        header: t(
          'recommendations::type.strategy-learning.table.head.cost.label',
        ),
        cell: ({
          row: {
            original: { cost },
          },
        }) => (
          <span
            dangerouslySetInnerHTML={{ __html: formatMoney(cost, 'RUB') }}
          />
        ),
      },
      {
        id: 'stop_days_count',
        header: t(
          'recommendations::type.strategy-learning.table.head.stop_days_count.label',
        ),
        cell: ({
          row: {
            original: { stop_days_count = '' },
          },
        }) => stop_days_count ,
      },
      {
        id: 'week_budget',
        header: t(
          'recommendations::type.strategy-learning.table.head.week_budget.label',
        ),
        cell: ({
          row: {
            original: { week_budget },
          },
        }) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatMoney(week_budget, 'RUB'),
            }}
          />
        ),
      },
      {
        id: 'day_budget',
        header: t(
          'recommendations::type.strategy-learning.table.head.day_budget.label',
        ),
        cell: ({
          row: {
            original: { day_budget },
          },
        }) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatMoney(day_budget, 'RUB'),
            }}
          />
        ),
      },
      {
        id: 'pay_for_conversion',
        header: t(
          'recommendations::type.strategy-learning.table.head.pay_for_conversion.label',
        ),
        cell: ({
          row: {
            original: { pay_for_conversion },
          },
        }) =>
          t(
            'recommendations::type.strategy-learning.table.pay_for_conversion.value',
            { context: pay_for_conversion.toString() },
          ),
      },
      {
        id: 'strategy_name',
        header: t(
          'recommendations::type.strategy-learning.table.head.strategy_name.label',
        ),
        cell: ({
          row: {
            original: { strategy_name },
          },
        }) => strategy_name ?? '',
      },
      {
        id: 'strategy_type',
        header: t(
          'recommendations::type.strategy-learning.table.head.strategy_type.label',
        ),
        cell: ({
          row: {
            original: { strategy_type },
          },
        }) =>
          t(
            `recommendations::type.filters.strategy_types.options.${strategy_type}`,
          ),
      },
      {
        id: 'account_external_id',
        header: t(
          'recommendations::type.strategy-learning.table.head.account_external_id.label',
        ),
        cell: ({
          row: {
            original: { account_external_id = ''},
          },
        }) => account_external_id,
      },
    ],
    showHeader: true,
    showFooter: false,
    onSortingChange: setSorting,
    onColumnVisibilityChange: setColumnVisibility,
    className: styles['table'],
    getRowId: ({ external_id }) => external_id,
    ...rest,
  }
}

